import { FETCH_AREA_SUMMARY_GRID_TYPE_WISE_COUNT, FETCH_AREA_SUMMARY_TYPE_WISE_LOCATION_UTILIZATION, FETCH_AREA_SUMMARY_LOCATIONS_BY_UTILIZATION_BUCKET, FETCH_AREA_SUMMARY_SKU_STOCKS, FETCH_AREA_SUMMARY_SKU_LOCATION_DETAIL } from "../types"

const INIT_STATE = {
    gridTypeWiseCountData: null,
    typeWiseLocationUtilizationData: null,
    locationsByUtilizationBucketData: null,
    skuStocksData: [],
    skuLocationDetailData: null
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_AREA_SUMMARY_GRID_TYPE_WISE_COUNT: return { ...state, gridTypeWiseCountData: action?.payload || null }
        case FETCH_AREA_SUMMARY_TYPE_WISE_LOCATION_UTILIZATION: return { ...state, typeWiseLocationUtilizationData: action?.payload || null }
        case FETCH_AREA_SUMMARY_LOCATIONS_BY_UTILIZATION_BUCKET: return { ...state, locationsByUtilizationBucketData: action?.payload || null }
        case FETCH_AREA_SUMMARY_SKU_STOCKS: return { ...state, skuStocksData: action?.payload || [] }
        case FETCH_AREA_SUMMARY_SKU_LOCATION_DETAIL: return { ...state, skuLocationDetailData: action?.payload || null }

        default: return state
    }
}
